import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import { Card } from "src/components/Layout/Card";
import * as AF from "src/types/formTemplate";

type Props = {
  section: AF.V2.SchoolRankingSection;
  onUpdate?: (schoolRanking: AF.V2.SchoolRankingSection) => void;
};
export const SchoolRankingForm: React.FC<Props> = ({ section }) => (
  <Card display="flex" flexDirection="column" showBorder gap="3">
    <SchoolRankingFormView schoolRanking={section} />
  </Card>
);

type ViewProps = {
  schoolRanking: AF.V2.SchoolRankingSection;
};
export const SchoolRankingFormView: React.FC<ViewProps> = ({
  schoolRanking,
}) => {
  return (
    <Flex direction="column" gap="3">
      <Text fontWeight="bold">Link URL</Text>
      <Text fontSize="sm" whiteSpace="pre-wrap">
        {schoolRanking.exploreUrl ?? "None"}
      </Text>
      <Text fontWeight="bold">Min. Schools</Text>
      <Text fontSize="sm" whiteSpace="pre-wrap">
        {schoolRanking.minSchools}
      </Text>
      <Text fontWeight="bold">Max. Schools</Text>
      <Text fontSize="sm" whiteSpace="pre-wrap">
        {schoolRanking.maxSchools}
      </Text>
      <Text fontWeight="bold">Ordered Ranking</Text>
      <Text fontSize="sm" whiteSpace="pre-wrap">
        {schoolRanking.rankingEnabled ? "Yes" : "No"}
      </Text>
    </Flex>
  );
};
